import { request, API_V1_PREFIX } from "./client";
import type { ReportData } from "./types";

export async function getReports(token: string, schoolProfileId?: string): Promise<ReportData[]> {
  const query = schoolProfileId ? `?school_profile_id=${schoolProfileId}` : "";
  return request<ReportData[]>(`${API_V1_PREFIX}/reports${query}`, { method: "GET" }, { token });
}
